// extracted by mini-css-extract-plugin
module.exports = {"container":"WhalePartners_container__2ojFW"};